import Vue from 'vue'
import VueRouter, {Route, RouteConfig} from 'vue-router'
import Home from '../views/Home.vue'
import Docs from '../views/Docs.vue'

import Color from '@/content/3-guidelines/Color.vue'
import Passthrough from '@/content/Passthrough.vue'
import Usage from "@/content/1-start/Usage.vue"
import Animation from "@/content/3-guidelines/Animation.vue"
import Spacing from "@/content/3-guidelines/Spacing.vue"
import CandidateBubble from "@/content/8-constructs/CandidateBubble.vue"
import Changelog from "@/content/1-start/Changelog.vue"
import Meridian from "@/content/6-patterns/Meridian.vue"
import Navigator from "@/content/6-patterns/Navigator.vue"
import ActionBox from "@/content/6-patterns/ActionBox.vue"
import Button from "@/content/5-components/Button.vue"
import Timestamp from "@/content/5-components/Timestamp.vue"
import LocaleProvider from "@/content/4-Foundation/LocaleProvider.vue"
import Loaders from "@/content/4-Foundation/Loaders.vue"
import Installation from "@/content/1-start/Installation.vue"
import Toolbar from "@/content/6-patterns/Toolbar.vue"
import Terminology from "@/content/5-components/Terminology.vue"
import Utilities from "@/content/1-start/Utilities.vue"
import V2FormViewer from "@/prototypes/v2-form-viewer/V2FormViewer.vue"
import Inspector from "@/content/6-patterns/Inspector.vue"
import Confirmation from "@/content/6-patterns/Confirmation.vue"
import TextProvider from "@/content/4-Foundation/TextProvider.vue"
import Dummy from "@/content/Dummy.vue"
import JobTile from "@/content/8-constructs/JobTile.vue"
import Grammar from "@/content/3-guidelines/Grammar.vue"
import {playgroundRoutes} from "@/router/playground.routes"
import {adminPlaygroundRoutes} from "@/router/admin-playground.routes"
import Icons from "@/content/3-guidelines/Icons.vue"
import Paginator from "@/content/5-components/Paginator.vue"
import AttributeSticker from "@/content/8-constructs/AttributeSticker.vue"
import TightIntegration from "@/content/2-principles/TightIntegration.vue"
import DevExperience from "@/content/2-principles/DevExperience.vue"
import FutureAdjustable from "@/content/2-principles/FutureAdjustable.vue"
import Timeline from "@/content/5-components/Timeline.vue"
import Table from "@/content/6-patterns/Table.vue"
import Breakdown from "@/content/6-patterns/Breakdown.vue"
import Link from "@/content/5-components/Link.vue"
import Page from "@/content/6-patterns/Page.vue"
import Money from "@/content/5-components/Money.vue"
import ScoreBadge from "@/content/8-constructs/ScoreBadge.vue"
import Callout from "@/content/5-components/Callout.vue"
import Pipeline from "@/content/6-patterns/Pipeline.vue"
import Sheet from "@/content/6-patterns/Sheet/Sheet.vue"
import SheetExample from "@/content/6-patterns/Sheet/SheetExample.vue"
import Workbench from "@/content/6-patterns/Workbench.vue"
import SheetExampleInner from "@/content/6-patterns/Sheet/SheetExampleInner.vue"
import DropdownMenu from "@/content/6-patterns/DropdownMenu.vue"
import TextField from "@/content/7-forms/TextField.vue"
import FormsLayout from "@/content/7-forms/overview/FormsLayout.vue"
import FormsOverview from "@/content/7-forms/overview/FormsOverview.vue"
import Glossary from "@/content/3-guidelines/Glossary.vue"
import Echo from '@/content/5-components/Echo.vue'
import Article from "@/content/5-components/Article.vue"
import Spotlight from "@/content/6-patterns/Spotlight.vue"
import Datum from "@/content/5-components/Datum.vue"
import DraftingTable from "@/content/6-patterns/DraftingTable.vue"
import FormsValidation from "@/content/7-forms/overview/FormValidation.vue"
import StructuralButton from "@/content/9-helpers/StructuralButton.vue"
import SelectField from "@/content/7-forms/SelectField.vue"
import Nametag from "@/content/8-constructs/Nametag.vue"
import Dialog from "@/content/6-patterns/Dialog.vue"
import Checkbox from "@/content/7-forms/Checkbox.vue"
import Explorer from "@/content/6-patterns/Explorer.vue"
import ColorPicker from "@/content/7-forms/ColorPicker.vue"
import JdsMeridian from '@/design-system/patterns/Meridian/JdsMeridian.vue';
import ReactionPanel from "@/content/5-components/ReactionPanel.vue"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        redirect: '/docs/start/installation'
    },
    {
        path: '/prototype/v2-form-viewer',
        name: 'v2-form-viewer',
        component: V2FormViewer,
    },
    playgroundRoutes,
    adminPlaygroundRoutes,
    {
        path: '/docs',
        name: 'Docs',
        component: Docs,
        children: [
            {
                path: 'start',
                component: Passthrough,
                children: [
                    {
                        path: 'changelog',
                        name: 'docs.start.changelog',
                        component: Changelog
                    },
                    {
                        path: 'installation',
                        name: 'docs.start.installation',
                        component: Installation
                    },
                    {
                        path: 'usage',
                        name: 'docs.start.usage',
                        component: Usage
                    },
                    {
                        path: 'utilities',
                        name: 'docs.start.utilities',
                        component: Utilities
                    },
                ]
            },
            {
                path: 'principles',
                component: Passthrough,
                children: [
                    {
                        path: 'dev-experience',
                        name: 'docs.principles.dev-experience',
                        component: DevExperience
                    },
                    {
                        path: 'future-adjustable',
                        name: 'docs.principles.future-adjustable',
                        component: FutureAdjustable
                    },
                    {
                        path: 'tight-integration',
                        name: 'docs.principles.tight-integration',
                        component: TightIntegration
                    },
                ]
            },
            {
                path: 'guidelines',
                component: Passthrough,
                children: [
                    {
                        path: 'animation',
                        name: 'docs.guidelines.animation',
                        component: Animation
                    },
                    {
                        path: 'color',
                        name: 'docs.guidelines.color',
                        component: Color
                    },
                    {
                        path: 'glossary',
                        name: 'docs.guidelines.glossary',
                        component: Glossary
                    },
                    {
                        path: 'grammar',
                        name: 'docs.guidelines.grammar',
                        component: Grammar
                    },
                    {
                        path: 'icons',
                        name: 'docs.guidelines.icons',
                        component: Icons
                    },
                    {
                        path: 'spacing',
                        name: 'docs.guidelines.spacing',
                        component: Spacing
                    },
                ]
            },
            {
                path: 'foundation',
                component: Passthrough,
                children: [
                    {
                        path: 'loaders',
                        name: 'docs.foundation.loaders',
                        component: Loaders
                    },
                    {
                        path: 'locale-provider',
                        name: 'docs.foundation.locale-provider',
                        component: LocaleProvider
                    },
                    {
                        path: 'text-provider',
                        name: 'docs.foundation.text-provider',
                        component: TextProvider
                    },
                ]
            },
            {
                path: 'components',
                component: Passthrough,
                children: [
                    {
                        path: 'article',
                        name: 'docs.components.article',
                        component: Article
                    },
                    {
                        path: 'button',
                        name: 'docs.components.button',
                        component: Button
                    },
                    {
                        path: 'datum',
                        name: 'docs.components.datum',
                        component: Datum
                    },
                    {
                        path: 'callout',
                        name: 'docs.components.callout',
                        component: Callout,
                    },
                    {
                        path: 'echo',
                        name: 'docs.components.echo',
                        component: Echo,
                    },
                    {
                        path: 'link',
                        name: 'docs.components.link',
                        component: Link
                    },
                    {
                        path: 'money',
                        name: 'docs.components.money',
                        component: Money
                    },
                    {
                        path: 'paginator',
                        name: 'docs.components.paginator',
                        component: Paginator
                    },
                    {
                        path: 'reaction-panel',
                        name: 'docs.components.reaction-panel',
                        component: ReactionPanel
                    },
                    {
                        path: 'terminology',
                        name: 'docs.components.terminology',
                        component: Terminology
                    },
                    {
                        path: 'timeline',
                        name: 'docs.components.timeline',
                        component: Timeline
                    },
                    {
                        path: 'timestamp',
                        name: 'docs.components.timestamp',
                        component: Timestamp
                    },
                ]
            },
            {
                path: 'patterns',
                component: Passthrough,
                children: [
                    {
                        path: 'action-box',
                        name: 'docs.patterns.action-box',
                        component: ActionBox
                    },
                    {
                        path: 'breakdown',
                        name: 'docs.patterns.breakdown',
                        component: Breakdown
                    },
                    {
                        path: 'confirmation',
                        name: 'docs.patterns.confirmation',
                        component: Confirmation
                    },
                    {
                        path: 'dialog',
                        name: 'docs.patterns.dialog',
                        component: Dialog
                    },
                    {
                        path: 'drafting-table',
                        name: 'docs.patterns.drafting-table',
                        component: DraftingTable
                    },
                    {
                        path: 'dropdown-menu',
                        name: 'docs.patterns.dropdown-menu',
                        component: DropdownMenu
                    },
                    {
                        path: 'explorer',
                        name: 'docs.patterns.explorer',
                        component: Explorer
                    },
                    {
                        path: 'inspector',
                        name: 'docs.patterns.inspector',
                        component: Inspector
                    },
                    {
                        path: 'meridian',
                        name: 'docs.patterns.meridian',
                        component: Meridian
                    },
                    {
                        path: 'navigator',
                        name: 'docs.patterns.navigator',
                        component: Navigator,
                        children: [
                            {
                                path: ':dummy',
                                name: 'docs.patterns.navigator.dummy',
                                component: Dummy
                            }
                        ]
                    },
                    {
                        path: 'page',
                        name: 'docs.patterns.page',
                        component: Page
                    },
                    {
                        path: 'pipeline',
                        name: 'docs.patterns.pipeline',
                        component: Pipeline
                    },
                    {
                        path: 'sheet',
                        name: 'docs.patterns.sheet',
                        component: Sheet,
                        children: [
                            {
                                path: 'example',
                                name: 'docs.patterns.sheet.example',
                                component: SheetExample,
                                children: [
                                    {
                                        path: 'example',
                                        name: 'docs.patterns.sheet.example2',
                                        component: SheetExampleInner
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'spotlight',
                        name: 'docs.patterns.spotlight',
                        component: Spotlight
                    },
                    {
                        path: 'table',
                        name: 'docs.patterns.table',
                        component: Table
                    },
                    {
                        path: 'toolbar',
                        name: 'docs.patterns.toolbar',
                        component: Toolbar
                    },
                    {
                        path: 'workbench',
                        name: 'docs.patterns.workbench',
                        component: Workbench
                    },
                ]
            },
            {
                path: 'forms',
                component: Passthrough,
                children: [
                    {
                        path: "overview",
                        name: 'docs.forms.overview',
                        component: FormsOverview
                    },
                    {
                        path: "layout",
                        name: 'docs.forms.layout',
                        component: FormsLayout
                    },
                    {
                        path: "validation",
                        name: 'docs.forms.validation',
                        component: FormsValidation
                    },

                    {
                        path: "checkbox",
                        name: 'docs.forms.checkbox',
                        component: Checkbox
                    },
                    {
                        path: "color-picker",
                        name: 'docs.forms.color-picker',
                        component: ColorPicker
                    },
                    {
                        path: "select-field",
                        name: 'docs.forms.select-field',
                        component: SelectField
                    },
                    {
                        path: "text-field",
                        name: 'docs.forms.text-field',
                        component: TextField
                    },
                ]
            },
            {
                path: 'constructs',
                component: Passthrough,
                children: [
                    {
                        path: "attribute-sticker",
                        name: 'docs.constructs.attribute-sticker',
                        component: AttributeSticker
                    },
                    {
                        path: 'candidate-bubble',
                        name: 'docs.constructs.candidate-bubble',
                        component: CandidateBubble
                    },
                    {
                        path: 'job-tile',
                        name: 'docs.constructs.job-tile',
                        component: JobTile
                    },
                    {
                        path: 'nametag',
                        name: 'docs.constructs.nametag',
                        component: Nametag
                    },
                    {
                        path: 'score-badge',
                        name: 'docs.constructs.score-badge',
                        component: ScoreBadge
                    },
                ]
            },
            {
                path: 'helpers',
                component: Passthrough,
                children: [
                    {
                        path: "structural-button",
                        name: 'docs.helpers.structural-button',
                        component: StructuralButton
                    },
                ]
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {selector: to.hash};
        }
        return {x: 0, y: 0};
    }
})

export default router
